export const RELATED_PARTS_ROOT_URL = '/related_parts';
